<template>
  <vue-dialog :dialog-data="dialogData" @confirm="confirm">
    <el-form :model="form" label-width="auto" :rules="rules" ref="form" size="small">
      <el-form-item label="厂商名称" prop="name">
        <el-input v-model.trim="form.name" clearable placeholder="输入或复制粘贴厂商"></el-input>
      </el-form-item>
    </el-form>
  </vue-dialog>
</template>

<script>
  import {inputEmpty} from '@utils/validate'
  export default {
    name: "CompanyOperate",
    props: {dialogData: Object},
    data() {
      return {
        form: {
          name: "",
        },
        rules: {
          name: [inputEmpty('厂商名称')],
        },
      }
    },
    created() {
      let row = this.dialogData.row;
      if (row) {
        Object.keys(this.form).forEach(key => key in row && (this.form[key] = row[key]));
      }
    },
    methods: {
      confirm() {
        let row = this.dialogData.row;
        row ? this.revise(row) : this.add();
      },
      add() {
        this.$refs["form"].validate(async isOk => {
          if (isOk) {
            let nv = {};
            this.copyObjValue(nv, this.form);
            let res = await this.$Http.addCompany(nv);
            if (res) {
              this.msgSuccess("添加成功");
              this.$emit("table-reload");
              this.dialogData.visible = false;
            }
          }
        });
      },
      revise(row) {
        let nv = {};
        Object.entries(this.form).forEach(([key, value]) => value !== row[key] && (nv[key] = value));
        if (Object.keys(nv).length) {
          this.$refs["form"].validate(isOk => {
            if (isOk) {
              this.openConfirm("修改该厂商", async () => {
                nv.company_id = row.id;
                let res = await this.$Http.reviseCompany(nv);
                if (res) {
                  this.msgSuccess("修改成功");
                  this.$emit("table-reload");
                  this.dialogData.visible = false;
                }
              });
            }
          });
        } else {
          this.msgInfo("您尚未做任何修改")
        }
      },
    }
  }
</script>

<style scoped>

</style>
